import {
  TableData,
  TableHeaderCategoryConfig,
} from "../../../../../components/tables/tableContext/TableContext";
import { UndeliveredPackagesCentralizerDataInterface } from "../../../../../redux/interfaces/raports.interface";
import { getDateAndTime } from "../../../../../utils/dateAndTime";

export const undeliveredReason = [
  {
    value: 1,
    label: "Colet ramas in masina",
  },
  {
    value: 2,
    label: "Colet scanat in nodul gresit",
  },
  {
    value: 3,
    label: "Colet nescanat in nod",
  },
];

const getUndeliveredReasonLabel = (value: any) => {
  const currentStatus = undeliveredReason.find((item) => {
    return item.value === value;
  });
  return currentStatus?.label;
};

export const undeliveredPackagesCentralizerTableHeader: TableHeaderCategoryConfig[] =
  [
    {
      label: "Nr. expeditie",
      value: "doc_trans",
      minW: 125,
      withSearch: true,
    },
    {
      label: "Client",
      value: "client",
      minW: 125,
    },
    {
      label: "Pct. preluare",
      value: "pctpreluare",
      minW: 125,
      withSearch: true,
    },
    {
      label: "Pct. livrare",
      value: "pctlivrare",
      minW: 125,
      withSearch: true,
    },
    {
      label: "Adresa",
      value: "adresa",
      minW: 125,
      withSearch: true,
    },
    {
      label: "Nod-Destinatie",
      value: "nodDestinatie",
      minW: 125,
    },
    {
      label: "Motiv nelivrare",
      value: "tip_eroare",
      minW: 125,
      withFilter: [{ value: 0, label: "Toate" }, ...undeliveredReason],
    },
    {
      label: "Data crearii",
      value: "data_crearii",
      minW: 125,
      withDatePicker: {
        maxDate: new Date(),
        withClearData: true,
      },
    },
  ];

export const getUndeliveredPackagesCentralizerTableData = (
  data: UndeliveredPackagesCentralizerDataInterface[],
): TableData[] =>
  data.map((item) => {
    const getTitleColor = () => {
      const tipEroare = item.tip_eroare;

      if (tipEroare === 1) return "purple";
      if (tipEroare === 2) return "green";
      if (tipEroare === 3) return "blue";
      return "black";
    };

    const getBadgeColor = () => {
      const tipEroare = item.tip_eroare;
      if (tipEroare === 1) return "light-info";
      if (tipEroare === 2) return "light-success";
      if (tipEroare === 3) return "light-primary";
      return "light-info";
    };

    const isColdBox = item?.tip_ambalaj === 75;

    const coldBoxStyle = {
      color: isColdBox ? "#90D5FF" : getTitleColor(),
    };

    return {
      id: item.id_doctrans_detl,
      crudData: item,
      data: [
        {
          title: item.doc_trans,
          titleStyle: coldBoxStyle,
        },
        {
          title: item.client,
          titleStyle: {
            color: getTitleColor(),
          },
        },
        {
          title: item.pctpreluare,
          titleStyle: {
            color: getTitleColor(),
          },
        },
        {
          title: item.pctlivrare,
          titleStyle: {
            color: getTitleColor(),
          },
        },
        {
          title: item.adresa,
          titleStyle: {
            color: getTitleColor(),
          },
        },
        {
          title: item.nodDestinatie,
          titleStyle: {
            color: getTitleColor(),
          },
        },
        {
          title: getUndeliveredReasonLabel(item.tip_eroare),
          titleStyle: {
            color: getTitleColor(),
          },
        },
        {
          badges: [
            {
              badgeText: item.data_crearii
                ? getDateAndTime(item.data_crearii)
                : "-",
              badgeColor: getBadgeColor(),
            },
          ],
        },
      ],
    };
  });
